module.exports = __webpack_public_path__ + "static/media/animal.18443205.svg";